module.exports = __webpack_public_path__ + "img/heyc.f9fbdf7a.svg";